var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"main-container responsive-height"},[_c('ClientUserStatistics'),_c('ProfileBar'),_c('AllLevelTabs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }